import React from "react";
import { useLang } from "../../lib/LanguageContext";
import SectionHeading from "../SectionHeading";

export default function Audience() {
    const { t } = useLang();
    return (
        <section
            id="audience"
            className="relative py-20 sm:py-24 md:py-32 border-t border-[color:var(--sau-border)]"
            data-testid="sau-audience"
        >
            <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12">
                    <div className="lg:col-span-4">
                        <SectionHeading eyebrow={t.audience.eyebrow} title={t.audience.title} />
                        <p className="sau-reveal mt-5 sm:mt-6 text-[15px] sm:text-base text-[color:var(--sau-text-2)] leading-relaxed">
                            {t.audience.body}
                        </p>
                    </div>
                    <div className="lg:col-span-8">
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                            {t.audience.items.map((a, i) => (
                                <div
                                    key={`aud-${i}`}
                                    className="sau-reveal sau-card rounded-2xl p-6 flex items-start gap-4"
                                    data-testid={`sau-audience-${i}`}
                                >
                                    <div className="mt-1 w-8 h-8 flex-shrink-0 rounded-full border border-[color:var(--sau-border)] flex items-center justify-center text-[11px] text-[color:var(--sau-accent)] font-medium">
                                        {String(i + 1).padStart(2, "0")}
                                    </div>
                                    <div>
                                        <h3 className="text-[15px] font-semibold text-[color:var(--sau-text)]">{a.title}</h3>
                                        <p className="mt-1.5 text-sm text-[color:var(--sau-text-2)] leading-relaxed">
                                            {a.body}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
